<dx-lookup class="multiple-lookup-selection"
  [items]="options"
  [searchExpr]="['name', 'value']"
  valueExpr="value"
  itemTemplate="listItem"
  fieldTemplate="fieldItem"
  applyValueMode="useButtons"
  applyButtonText="Done"
  [placeholder]="customPlaceholder"
  [showCancelButton]="false"
  [disabled]="disabled"
  (onClosed)="onConfirm()"
>
  <div *dxTemplate="let item of 'listItem'">
    <mat-checkbox
      class="checkbox"
      [checked]="checked(item)"
      color="primary"
      (change)="checkboxChange(item, $event)"
    >{{item.name}}</mat-checkbox>
  </div>
  <div *dxTemplate="let item of 'fieldItem'">
    <div [ngClass]="{ 'placeholder': selectedOptions.length === 0, 'inputField': selectedOptions.length > 0 }">{{fieldText}}</div>
  </div>
</dx-lookup>
